/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    query SenderIdDirectoryReadQuery($senderIdDirectoryToSearch: String, $take: PositiveInt, $skip: Int) {
      SenderIdDirectoryRead(senderIdDirectoryToSearch: $senderIdDirectoryToSearch, take: $take, skip: $skip) {
        id,
        createdAt,
        updatedAt,
        displayName,
        status,
        message,
        _totalCount,
        _count {
          SenderId
        }
    }
  }
`
